<template>
    <div>
        <AccidentInfoWin v-show="false"
                         v-on:loaded-accident-info="loadedAccidentInfoHandle"
                         ref="accidentInfoWin" />
        <BuildingAlarmWin v-show="false"
                         v-on:loaded-building-alarm="loadedBuildingAlarmHandle"
                         ref="buildingAlarmWin" />
        <FacilityInfoWin v-show="false"
                         v-on:loaded-facility-info="loadedFacilityInfoHandle"
                         ref="facilityInfoWin" />
        <FrameWin :frame-src="frameSrc" v-if="showFrameWin" />
    </div>
</template>

<script>
import { $_TYPE, $_NM, $_DKD, $_WC } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';
import { mapGetters } from "vuex";
import AccidentInfoWin from "@/views/realtime/AccidentInfoWin.vue";
import BuildingAlarmWin from "@/views/realtime/BuildingAlarmWin.vue";
import FacilityInfoWin from "@/views/common/FacilityInfoWin.vue";
import FrameWin from "@/views/common/FrameWin.vue";

export default {
    components:{
        AccidentInfoWin,
        BuildingAlarmWin,
        FacilityInfoWin,
        FrameWin,
    },
    data(){
        return {
            groupName: 'Accident',
            showFrameWin: false,
            frameSrc: '',
        };
    },
    computed: {
        ...mapGetters({
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus: 'getSelectedSubMenus',
            subMenuList: 'getSubMenuList',
            accidentList: 'getAccidentList',
            buildingAlarmList: 'getBuildingAlarmList',
            buildingPermitList: 'getBuildingPermitList',
        }),
    },
    watch: {
        selectedSubMenus: {
            immediate: false,
            handler(newVal, oldVal) {
                this.placeMarkers();
                if(newVal.length > 0) {
                    newVal.forEach((d)=>{
                        if(d > 10) {
                            this.showAccidentFacMarkers(d);
                        }
                    });
                }
            }
        },
        accidentList: {
            immediate: false,
            handler: function (newVal, oldVal) {
                this.placeMarkers();
            }
        },
    },
    created() {
        this.$eventBus.$on('NaverMap::map-loaded', (map)=>{
            this.setRecognizer();
        });

        this.$eventBus.$on('FrameWin::close-win', () => {
            this.showFrameWin = false;
            this.frameSrc = '';
        });
    },
    methods: {
        placeMarkers(){
            if(typeof this.geoJsonDrawing !== $_TYPE.UNDEF) {
                if (this.selectedTopMenu === 'Accident') {
                    this.removeMarker(this.groupName);
                    this.accidentList.forEach(accident => {
                        if(this.selectedSubMenus.includes(accident.val2)) {
                            accident.marker = this.makeMarker(this.groupName, accident, () => {
                                this.$store.dispatch("SET_SELECTED_MARKER", accident.marker);
                                this.$refs.accidentInfoWin.setAccidentInfo(accident);
                            }, 'marker_accident_' + accident.val2 + '.png', "img/marker/", $_NM.MARKER_W, $_NM.MARKER_H);
                        }
                    });
                    this.showMarkers(this.groupName, true);
                }
            }
        },
        showAccidentFacMarkers(dataKdSqno){
            if($_DKD.BUILDING_ALARM === Number(dataKdSqno)) {
                if(!this.hasMarkers(dataKdSqno)) {
                    this.buildingAlarmList.forEach((fac)=>{
                        fac.marker = this.makeMarker(dataKdSqno, fac, (event, data, marker)=>{
                            this.alarmInfo = data;
                            this.$refs.buildingAlarmWin.setAlarmInfo(data);
                        }, 'marker_003_2.png', '/img/marker/', $_NM.MARKER_W, $_NM.MARKER_H, fac.val3);
                    });

                    this.buildingPermitList.forEach((fac)=>{
                        fac.facName = "건축인허가";
                        fac.facNm = fac.val2 + ' ' + fac.val9;
                        fac.marker = this.makeMarker(dataKdSqno, fac, (event, data, marker)=>{
                            this.$refs.facilityInfoWin.setFacilityInfo(fac);
                        }, 'marker_003_3.png', '/img/marker/', $_NM.MARKER2_W, $_NM.MARKER2_H, fac.facNm);
                    });
                }
                this.showMarkers(dataKdSqno, true);
            }
        },
        loadedAccidentInfoHandle(content) {
            this.openInfoWin(content);
        },
        loadedBuildingAlarmHandle: function(content) {
            this.openInfoWin(content);
            $(".building-alarm-desc").click(()=>{
                if($_WC.viewScale === 2){
                    if(typeof this.selectedMarker !== $_TYPE.UNDEF && this.selectedMarker.OVERLAY_TYPE === 'Marker') {
                        this.map.setCenter(this.selectedMarker.position);
                    }
                    this.frameSrc = 'https://cis.seoul.go.kr/TotalAlimi_new/PopInfo.action?cmd=info1&pjt_cd=' + this.alarmInfo.val2;
                    this.showFrameWin = true;
                } else {
                    window.open('https://cis.seoul.go.kr/TotalAlimi_new/PopInfo.action?cmd=info1&pjt_cd=' + this.alarmInfo.val2);
                }
            });
            $(".self-close-btn").click(()=>{
                this.showFrameWin = false;
                this.frameSrc = '';
            });
        },
        loadedFacilityInfoHandle: function(content) {
            this.openInfoWin(content);
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
